
// 👉 Redirects
export const redirects = [
    // ℹ️ We are redirecting to different pages based on role.
    // NOTE: Role is just for UI purposes. ACL is based on abilities.
    {
        path: '/',
        name: 'index',
        redirect: to => {
            // TODO: Get type from backend
            const userData = localStorage.getItem('userData')
            const userRole = userData ? JSON.parse(userData)?.role : null
            if (userRole === 'Admin')
                return { name: 'apps-roles' }

            return { name: 'login', query: to.query }
        },
    },
    {
        path: '/pages/user-profile',
        name: 'pages-user-profile',
        redirect: () => ({ name: 'pages-user-profile-tab', params: { tab: 'profile' } }),
    },
    {
        path: '/pages/account-settings',
        name: 'pages-account-settings',
        redirect: () => ({ name: 'pages-account-settings-tab', params: { tab: 'account' } }),
    },
]
export const routes = [
    {
        path: '/pjob/:id/edit',
        name: 'pjob-edit',
        meta: {
            action: 'view',
            subject: 'orders',
        },
        component: () => import('@/pages/job/[id].vue'),
    },
    {
        path: '/pjob/new',
        name: 'pjob-new',
        meta: {
            action: 'view',
            subject: 'orders',
        },
        component: () => import('@/pages/job/index.vue'),
    },

]
